import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, CardContent } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import ClearIcon from '@material-ui/icons/Clear';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import {
  CommonButton,
} from '..';
import CommonTextField from '../CommonTextField';
import {
  getAllDeletedSites, getAllSites, getVendorSites, updateSearchQuery,
} from '../../redux/actions/sites';
import CommonSearch from '../CommonSearch';
import { showToast } from '../../Utils';
import { getSitesByCampaignNo, getSitesByEstimateNo } from '../../redux/actions/common';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ClientSitesFilter = ({
  campaignNo, cities, states, mediaTypes, fetchSites,
  updateQuery,
  currentLocation,
  fetchSiteAuditor,
}) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const currentRoute = useLocation();
  const query = useQuery();
  const history = useHistory();
  const [location, setLocation] = useState('')
  const [mediaType, setMediaTypes] = useState(null)
  const [state, setStates] = useState(null)
  const [city, setCities] = useState(null)
  const [filtered, setFilter] = useState(false)
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const filterSites = async () => {
    const sd = moment(startDate);
    const ed = moment(endDate);

    if (ed.diff(sd, 'days') < 0) {
      showToast('warning', 'End date should be greater then start date');
      return;
    }

    if (startDate) {
      if (query.has('campaignStartDate')) {
        query.set('campaignStartDate', sd.format('YYYY-MM-DD'))
      } else {
        query.append('campaignStartDate', sd.format('YYYY-MM-DD'))
      }
    }

    if (endDate) {
      if (query.has('campaignEndDate')) {
        query.set('campaignEndDate', ed.format('YYYY-MM-DD'))
      } else {
        query.append('campaignEndDate', ed.format('YYYY-MM-DD'))
      }
    }

    if (location && location.trim()) {
      if (query.has('locationName')) {
        query.set('locationName', location.trim())
      } else {
        query.append('locationName', location.trim())
      }
    }
    if (mediaType) {
      if (query.has('mediaTypeName')) {
        query.set('mediaTypeName', mediaType)
      } else {
        query.append('mediaTypeName', mediaType)
      }
    }
    if (state) {
      if (query.has('stateName')) {
        query.set('stateName', state)
      } else {
        query.append('stateName', state)
      }
    }
    if (city) {
      if (query.has('cityName')) {
        query.set('cityName', city)
      } else {
        query.append('cityName', city)
      }
    }
    setFilter(true)

    query.delete('page')
    await updateQuery(query.toString())
    history.push(currentLocation)
    if (user.userType === 'client') {
      fetchSites({ campaignNo, searchQuery: query.toString() });
    } else {
      fetchSiteAuditor({ estimateNo: campaignNo, searchQuery: query.toString() });
    }
  }

  const clearFilters = () => {
    setStartDate(null)
    setEndDate(null)
    setLocation('')
    setMediaTypes(null)
    setStates(null)
    setCities(null)
    setFilter(false)

    query.delete('page');
    updateQuery('');
    history.push(currentRoute.pathname);
    if (user.userType === 'client') {
      fetchSites({ campaignNo });
    } else {
      fetchSiteAuditor({ estimateNo: campaignNo });
    }
  }

  const handleChangeCity = (val) => {
    if (val) { setCities(val.value) } else { setCities(val) }
  }

  const handleChangeStates = (val) => {
    if (val) { setStates(val.value) } else { setStates(val) }
  }

  const handleChangeMedia = (val) => {
    if (val) { setMediaTypes(val.value) } else { setMediaTypes(val) }
  }

  const filterDisabled = !location.trim() && !mediaType && !state && !city && !startDate && !endDate

  return (
    <Card style={{ overflow: 'visible' }}>
      <br />
      <CardContent>
        <div className="row">
          <div className="col-3">
            <CommonSearch label="Media" value={mediaType} data={mediaTypes} onChange={handleChangeMedia} />
          </div>
          <div className="col-3">
            <CommonSearch label="State" value={state} data={states} onChange={handleChangeStates} />
          </div>
          <div className="col-3">
            <CommonSearch label="City" value={city} data={cities} onChange={handleChangeCity} />
          </div>
          <div className="col-3">
            <CommonTextField label="Location" value={location} placeholder="Location" handleChange={setLocation} />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">
            <span className="error">{startDate === undefined ? 'Please select valid date' : ''}</span>
            <br />
            <DayPickerInput
              value={startDate}
              placeholder="Start Date *"
              formatDate={formatDate}
              parseDate={parseDate}
              format="LL"
              onDayChange={(day) => setStartDate(day)}
              dayPickerProps={{
                selectedDays: startDate,
              }}
            />
          </div>
          <div className="col-3">
            <span className="error">{endDate === undefined ? 'Please select valid date' : ''}</span>
            <br />
            <DayPickerInput
              value={endDate}
              formatDate={formatDate}
              parseDate={parseDate}
              format="LL"
              placeholder="End Date *"
              onDayChange={(day) => setEndDate(day)}
              dayPickerProps={{
                selectedDays: endDate,
              }}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">
            <CommonButton
              className="wide-200"
              variant="outlined"
              color="primary"
              disabled={filterDisabled}
              startIcon={<FilterListIcon />}
              onClick={filterSites}
            >
              Filter Sites
            </CommonButton>
          </div>
          <div className="col-3">
            <CommonButton
              className="wide-200"
              variant="outlined"
              color="secondary"
              disabled={filterDisabled && !filtered}
              startIcon={<ClearIcon />}
              onClick={clearFilters}
            >
              Clear Filters
            </CommonButton>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const mapState = (state) => ({
  primaryQuery: state.sites.primaryQuery,
  cities: state.common.clientCities,
  states: state.common.clientStates,
  mediaTypes: state.common.clientMediaTypes,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  getVendorSitesFun: getVendorSites,
  updateQuery: updateSearchQuery,
  getDeleteSites: getAllDeletedSites,
  fetchSites: getSitesByCampaignNo,
  fetchSiteAuditor: getSitesByEstimateNo,
};

export default connect(mapState, mapActions)(ClientSitesFilter);
